import BaseTextInput from './implementation';

export default BaseTextInput;
